import { useState, useEffect } from 'react';
import { message } from 'antd';
import { authService } from '../services';
import type { User, LoginRequest } from '../types';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 初始化用户信息
  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('access_token');
      const userInfo = localStorage.getItem('user_info');

      if (token && userInfo) {
        try {
          const parsedUser = JSON.parse(userInfo);
          setUser(parsedUser);
          setIsAuthenticated(true);
          
          // 只在必要时验证token有效性，避免每次初始化都验证
          // token验证会在实际API请求时由axios拦截器处理
        } catch (error) {
          // 用户信息解析失败，清除本地存储
          console.error('用户信息解析失败:', error);
          authService.logout();
          setUser(null);
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  // 登录
  const login = async (credentials: LoginRequest) => {
    try {
      setLoading(true);
      const response = await authService.login(credentials);
      
      // 保存token和用户信息
      localStorage.setItem('access_token', response.access_token);
      localStorage.setItem('refresh_token', response.refresh_token);
      localStorage.setItem('user_info', JSON.stringify(response.user));
      
      setUser(response.user);
      setIsAuthenticated(true);
      message.success(response.message);
      
      return response;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // 登出
  const logout = () => {
    authService.logout();
    setUser(null);
    setIsAuthenticated(false);
    message.success('已成功登出');
  };

  return {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
  };
};
